import * as React from 'react';
import { FaMagic, FaTimes } from 'react-icons/fa';
import { personalakteStyles as ps, colors, shadows } from '../../employees/styles/personalakteStyles';

interface AutoAssignOverlayProps {
  showConfirm: boolean;
  onConfirm: () => void;
  onCancelConfirm: () => void;
  isAssigning: boolean;
  assignmentLogs: string[];
  onCloseOverlay: () => void;
}

function AutoAssignOverlay({
  showConfirm,
  onConfirm,
  onCancelConfirm,
  isAssigning,
  assignmentLogs,
  onCloseOverlay,
}: AutoAssignOverlayProps) {
  return (
    <>
      {showConfirm && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0, 0, 0, 0.4)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 5001,
          }}
          onClick={onCancelConfirm}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: colors.bgCard,
              borderRadius: '14px',
              padding: '20px',
              width: '340px',
              border: `1px solid ${colors.border}`,
              boxShadow: shadows.elevated,
              textAlign: 'center',
            }}
          >
            <div style={{
              width: '48px',
              height: '48px',
              borderRadius: '12px',
              background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(139, 92, 246, 0.25) 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 16px auto',
            }}>
              <FaMagic style={{ fontSize: '20px', color: '#8b5cf6' }} />
            </div>
            <h3 style={{ margin: '0 0 8px 0', fontSize: '15px', fontWeight: 700, color: colors.navy }}>
              Start Auto-Assignment?
            </h3>
            <p style={{ margin: '0 0 20px 0', fontSize: '12px', color: colors.textMuted, lineHeight: 1.5 }}>
              Employees will be automatically assigned to open shifts based on qualifications, availability, and working time constraints.
            </p>
            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
              <button
                onClick={onCancelConfirm}
                style={{
                  ...ps.buttonSecondary,
                  padding: '10px 20px',
                  fontSize: '12px',
                }}
              >
                Cancel
              </button>
              <button
                onClick={onConfirm}
                style={{
                  padding: '10px 20px',
                  borderRadius: '9999px',
                  border: 'none',
                  background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                  color: '#fff',
                  fontSize: '12px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  boxShadow: '0 2px 10px rgba(139, 92, 246, 0.3)',
                }}
              >
                Start
              </button>
            </div>
          </div>
        </div>
      )}

      {isAssigning && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0, 0, 0, 0.4)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 5001,
          }}
        >
          <div
            style={{
              background: colors.bgCard,
              borderRadius: '14px',
              padding: '16px',
              width: '90%',
              maxWidth: '500px',
              maxHeight: '80vh',
              display: 'flex',
              flexDirection: 'column',
              border: `1px solid ${colors.border}`,
              boxShadow: shadows.elevated,
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '8px',
                  background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(139, 92, 246, 0.25) 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <FaMagic style={{ fontSize: '14px', color: '#8b5cf6' }} />
                </div>
                <h3 style={{ margin: 0, fontSize: '14px', fontWeight: 700, color: colors.navy }}>
                  Auto-Assignment in progress...
                </h3>
              </div>
              <button
                onClick={onCloseOverlay}
                style={{
                  background: 'rgba(0, 0, 0, 0.05)',
                  border: 'none',
                  borderRadius: '6px',
                  width: '26px',
                  height: '26px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  color: colors.textMuted,
                  fontSize: '12px',
                }}
              >
                <FaTimes />
              </button>
            </div>

            <div
              style={{
                flex: 1,
                overflowY: 'auto',
                background: 'rgba(14, 19, 51, 0.03)',
                padding: '12px',
                borderRadius: '8px',
                fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, monospace',
                fontSize: '11px',
                maxHeight: '350px',
                border: '1px solid rgba(14, 19, 51, 0.08)',
              }}
            >
              {assignmentLogs.map((log, index) => (
                <div
                  key={index}
                  style={{
                    marginBottom: '4px',
                    padding: '2px 0',
                    color: log.includes('\u274C') ? colors.danger
                      : log.includes('\u2713') ? colors.success
                      : log.includes('\u26A0') ? colors.warning
                      : log.includes('===') ? colors.slate
                      : colors.textBody,
                    fontWeight: log.includes('===') ? 600 : 400,
                  }}
                >
                  {log}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AutoAssignOverlay;
